module.exports = __webpack_public_path__ + "img/switch-gender-female.14e47ba1.svg";